module.exports = __webpack_public_path__ + "static/img/zd.65bff5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zd.png
// module id = Qhgu
// module chunks = 0